import React, { Component } from "react";
import { Link } from "react-router-dom";

import { loading } from "../components/loading.js";
import ICON from "./home/icons.js";

import "../assets/css/homepage.css";

// ★ ใช้กล่อง hm-soon ชุดเดียวกับหน้าเว็บ (ไม่พึ่ง class ของ bootstrap/หลังบ้านแล้ว)
export default class Notfound extends Component {
  componentDidMount() {
    loading(false);
    document.title = "ไม่พบหน้าที่ต้องการ";
  }

  render() {
    return (
      <div className="mn-home">
        <div className="hm-container py-5">
          <div className="hm-soon" style={{ minHeight: "60vh" }}>
            <span className="hm-soon__icon hm-ico">{ICON.info}</span>
            <div className="hm-soon__title">404 · ไม่พบหน้าเว็บไซต์ที่คุณต้องการ</div>
            <div className="hm-soon__desc">ลิงก์อาจพิมพ์ผิด หรือหน้านี้ถูกย้ายไปแล้ว</div>
            <Link to="/overview" className="hm-btn hm-btn--primary hm-btn--sm mt-3">
              กลับไปหน้าหลัก
            </Link>
            {!!process.env.REACT_APP_VERSION && (
              <small className="hm-muted mt-3">เวอร์ชั่น {process.env.REACT_APP_VERSION}</small>
            )}
          </div>
        </div>
      </div>
    );
  }
}
